var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style['worker-container']},[_c('span',{class:_vm.$style.title},[_vm._v(_vm._s(_vm.title))]),_vm._t("action")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }